import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import "@fontsource/poppins";
import "@fontsource/plus-jakarta-sans";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import WhatsAppWidget from "./components/WhatsappWidget";

// Component to handle scroll behavior
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

// Direct imports for all pages
import HomePage from "./pages/Homepage";
import FAQPage from "./pages/FAQPage";
import ProgramsPage from "./pages/ProgramsPage";
import StoriesPage from "./pages/StoriesPage";
import AboutPage from "./pages/AboutPage";
import StudyAbroadPage from "./pages/services/StudyAbroadPage";
import MigrationPage from "./pages/services/MigrationPage";
import FlightBookingPage from "./pages/services/FlightBookingPage";

// Create the router configuration
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <HomePage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
  {
    path: "/faq",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <FAQPage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
  {
    path: "/services",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <ProgramsPage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
  {
    path: "/stories",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <StoriesPage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
  {
    path: "/about",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <AboutPage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
  {
    path: "/services/study-abroad",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <StudyAbroadPage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
  {
    path: "/services/migration",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <MigrationPage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
  {
    path: "/services/flight-booking",
    element: (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <ScrollToTop />
        <Navbar />
        <main>
          <FlightBookingPage />
        </main>
        <WhatsAppWidget />
        <Footer />
      </div>
    ),
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
